import templateWorkflowsList from './workflowsList.template.html';

export default {
  template: templateWorkflowsList,
  bindings: {
    workflows: '=',
    onToggle: '&',
    onChange: '&',
    onReady: '&'
  },
  controller: class controller {
    constructor($rootScope, $filter, $mdMedia, listService) {
      'ngInject';
      /*
       * Controller Model
       * --------------------------------------------------------------------------------
       */
      var ctrl = this;
      ctrl.$mdMedia = $mdMedia;
      ctrl.natural = $rootScope.natural;
      ctrl.list = listService;
      ctrl.isOwner = $rootScope.CurrentAccount.id === $rootScope.CurrentOrganization.idOwner;
      ctrl.list.clear();

      /*
       * Methods
       * --------------------------------------------------------------------------------
       */
      this.initialize = function () {
        ctrl.list.setData(
          $filter('stStartingLetter')(ctrl.workflows, ctrl.list.getGroupingByFirstLetter())
        );
        ctrl.onReady({ list: ctrl.list });
      };
      this.toggle = function ($event, data) {
        ctrl.onToggle({ event: $event, data: data });
      };
      this.select = function (data) {
        var isSelected = ctrl.list.setSelected(data);
        ctrl.onChange({ list: ctrl.list, data: data, isSelected: isSelected });
      };

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      this.$onInit = function () {
        ctrl.initialize();
      };

      /*
       * Execute when bindings change
       * --------------------------------------------------------------------------------
       */
      this.$onChanges = function (changes) {
        if (changes.workflows && changes.workflows.currentValue) {
          ctrl.initialize();
        }
      };
    }
  }
};
